// Quiet, on-brand "coming soon" page for nav items not yet wired.
// Editorial: lots of whitespace, no exclamation marks.
interface ComingSoonProps {
  title: string;
  eta: string;
}

export function ComingSoonPage({ title, eta }: ComingSoonProps) {
  return (
    <div className="mx-auto max-w-2xl py-24 text-center">
      <p className="text-[11px] font-medium uppercase tracking-[0.12em] text-muted">
        {title}
      </p>
      <h1 className="mt-3 text-[32px] font-semibold leading-[1.15] tracking-[-1px] text-ink">
        On the way.
      </h1>
      <p className="mt-4 text-base text-brown-400">
        This surface is part of the next build phase ({eta}). The backend is
        already live — we're just connecting the UI.
      </p>
      <div className="mx-auto mt-12 h-1 w-12 rounded-full bg-peach-400" />
    </div>
  );
}
